import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6f5bf74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "testimonial-page pt-227 pb-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainNavbar = _resolveComponent("MainNavbar")!
  const _component_Testimonial4Content = _resolveComponent("Testimonial4Content")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainNavbar, {
      class: "bg-transparent fixed-top border-bottom",
      mwClass: "",
      className: "m-auto"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Testimonial4Content)
    ]),
    _createVNode(_component_MainFooter)
  ], 64))
}